import { ReactNode } from "react";
import "./CardLineItem.scss";

export interface CardLineItemProps {
  /**
   * The label of the card line item.
   */
  label?: string;
  /**
   * The right content of the card line item.
   */
  rightContent?: ReactNode;
}

const CardLineItem = function (props: CardLineItemProps) {
  const { label, rightContent } = props;

  return (
    <div className="v2-card-line-item">
      <div className="d-flex gap-xl justify-content-between">
        <p className="m-0 text-sm font-medium">{label}</p>
        <div className="text-right">{rightContent}</div>
      </div>
    </div>
  );
};

CardLineItem.defaultProps = {
  label: undefined,
  rightContent: undefined,
};

export default CardLineItem;
